import styled, { css } from 'styled-components'

import { StyledButtonBase } from 'common-styles'
import { Color } from 'root-constants'

type TPropsWrapper = {
  isShown: boolean
}

const commonTitleStyles = css`
  font-style: normal;
  font-weight: ${({ theme }) => theme.common.semiBoldFontWeight};
  text-align: center;
  color: ${Color.DARK};
`

export const StyledPaymentWaitingModal = {
  Wrapper: styled.div<TPropsWrapper>`
    display: flex;
    position: fixed;
    top: 0;
    left: 0;
    z-index: ${({ isShown }) => (isShown ? 100 : -1)};
    width: max(100%, var(--min-screen-width));
    height: calc(var(--full-height) - calc(var(--full-height) - 100%));
    overflow-y: auto;
    background-color: rgba(0, 0, 0, 0.25);
    opacity: ${({ isShown }) => (isShown ? 1 : 0)};
    transition-duration: 100ms;
    transition-property: opacity;
    transition-timing-function: ease-out;

    * {
      font-family: Rubik;
    }
  `,
  Content: styled.div`
    width: calc(100% - 40px);
    max-width: 320px;
    margin: auto;
    padding: 24px 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    border-radius: 10px;
    background-color: ${Color.WHITE};
  `,
  LottieContainer: styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
  `,
  Animation: styled.div`
    width: 132px;
    height: 132px;
  `,
  Title: styled.div`
    ${commonTitleStyles};
    padding: 5px 0 9px;
    font-size: 24px;
    line-height: 28px;
  `,
  Subtitle: styled.div`
    ${commonTitleStyles};
    padding: 10px 15px;
    font-size: 15px;
    line-height: 18px;
  `,
  ErrorSubtitle: styled.div`
    font-weight: 600;
    font-size: 24px;
    line-height: 28px;
    margin-bottom: 8px;
  `,
  ErrorInfo: styled.div`
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    color: ${Color.ERROR_SECONDARY};
    margin-bottom: 16px;
  `,
  SuccessSubtitle: styled.p`
    text-align: center;
    font-style: normal;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    color: ${Color.LIGHT};
  `,
  List: styled.ul`
    display: flex;
    flex-direction: column;
    gap: 8px;
    color: #15192080;
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    text-align: start;
    margin-bottom: 20px;
    padding: 0 8px;
  `,
  SuccessButton: styled.button`
    ${StyledButtonBase};
    margin-top: 32px;
    background-color: #8fdf2c;
    font-weight: ${({ theme }) => theme.common.semiBoldFontWeight};
  `,
  ErrorButton: styled.button`
    ${StyledButtonBase};
    font-weight: ${({ theme }) => theme.common.semiBoldFontWeight};
  `,
}
